import { render, staticRenderFns } from "./NavPrivateComponent.vue?vue&type=template&id=10094b9c"
import script from "./NavPrivateComponent.vue?vue&type=script&lang=js"
export * from "./NavPrivateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports